import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { IconButton, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { percent, displayDuration } from '../../utils/parsing';
import { Page, Row } from '../util/Page';
import HeartbeatsGraph from './HeartbeatsGraph';
import DeploymentConfig from './DeploymentConfig';

import './deployment-list.css';

const BuildingsDisplay = connect(
  ({
    entities: {
      buildings: { byId: buildingsById },
    },
  }) => ({
    buildingsById,
  })
)(({ buildings, buildingsById }) => {
  const buildingNameLink = (id) => {
    const name = buildingsById[id] ? buildingsById[id].name : `building ${id}`;
    return <Link to={`/explore/buildings/${name}?bid=${id}`}>{name}</Link>;
  };
  let content;
  let color;
  if (!buildings.length) {
    content = 'No buildings';
    color = 'error';
  } else if (buildings.length === 1) {
    content = buildingNameLink(buildings[0]);
  } else {
    content = `${buildings.length} buildings`;
  }
  return (
    <Typography className="assoc-buildings" color={color} variant="subtitle1">
      {content}
    </Typography>
  );
});

const Entry = ({ now, site, latestHeartbeat: hb, lastContact, buildings, onSelect }) => {
  const contact = lastContact && displayDuration(now - lastContact, 'millis');
  const uptime = hb && displayDuration(hb.uptime_seconds, 'seconds');
  return (
    <div>
      {site}
      <br />
      <br />
      <BuildingsDisplay buildings={buildings} />
      <br />
      <br />
      <div>
        {contact != null ? (
          <div>
            Last contact: {contact.val} {contact.unit} ago
          </div>
        ) : null}
        {hb != null ? (
          <>
            <div>
              Uptime: {uptime.val} {uptime.unit}
            </div>
            <div>
              CPU: {hb.load_1m?.toFixed(1)} / {hb.load_5m?.toFixed(1)} / {hb.load_15m?.toFixed(1)}{' '}
              {hb.cpu_temp_c && `at ${hb.cpu_temp_c} C`}
            </div>
            <div>Memory: {percent(hb.memory)} used</div>
            <div>Disk: {percent(hb.disk_usage)} used</div>
          </>
        ) : (
          <div>No recent heartbeats</div>
        )}
      </div>
      <div>
        <IconButton onClick={onSelect} size="large">
          <Edit />
        </IconButton>
      </div>
    </div>
  );
};

const DeploymentList = ({ deployments, latestHeartbeats, selected, onSelect }) => {
  const now = new Date().getTime();
  return deployments.map((d) => (
    <Page key={d.site}>
      <Row>
        <Entry
          now={now}
          site={d.site}
          latestHeartbeat={latestHeartbeats[d.site]}
          lastContact={d.last_heartbeat}
          buildings={d.buildings}
          onSelect={() => onSelect(d.site)}
        />
        <HeartbeatsGraph deployment={d} site={d.site} />
      </Row>
      {selected === d.site && <DeploymentConfig deployment={d} />}
    </Page>
  ));
};

export default connect(
  ({
    entities: {
      deployments: { deployments, latestHeartbeats },
    },
  }) => ({
    deployments,
    latestHeartbeats,
  })
)(DeploymentList);
